
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 7.124c-1.861 0-3.375-1.514-3.375-3.375S17.639.374 19.5.374s3.375 1.514 3.375 3.375-1.514 3.375-3.375 3.375zm0-5.25c-1.034 0-1.875.841-1.875 1.875s.841 1.875 1.875 1.875 1.875-.841 1.875-1.875-.841-1.875-1.875-1.875zM19.5 24c-1.654 0-3-1.346-3-3v-3.128A2.26 2.26 0 0115 15.75v-4.5a3.754 3.754 0 013.75-3.75h1.5A3.754 3.754 0 0124 11.25v4.5a2.26 2.26 0 01-1.5 2.122V21c0 1.655-1.346 3-3 3zm-.75-15a2.252 2.252 0 00-2.25 2.25v4.5c0 .414.336.75.75.75s.75.337.75.75V21c0 .827.673 1.5 1.5 1.5S21 21.827 21 21v-3.75c0-.414.336-.75.75-.75s.75-.336.75-.75v-4.5c0-1.24-1.009-2.25-2.25-2.25h-1.5zM.75 23.999a.75.75 0 010-1.5h.879a2.231 2.231 0 01-.129-.75v-3a2.252 2.252 0 012.25-2.25v-.75A2.252 2.252 0 016 13.499h1.5a2.252 2.252 0 012.25 2.25v.75a2.252 2.252 0 012.25 2.25v3c0 .259-.044.511-.129.75h2.379a.75.75 0 010 1.5H.75zm3-6a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h6a.75.75 0 00.75-.75v-3a.75.75 0 00-.75-.75h-6zm4.5-1.5v-.75a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75v.75h3zM2.25 10.499A2.252 2.252 0 010 8.249v-6a2.252 2.252 0 012.25-2.25h10.5A2.252 2.252 0 0115 2.249v4.5a.75.75 0 01-1.5 0v-4.5a.75.75 0 00-.75-.75H2.25a.75.75 0 00-.75.75v6c0 .414.336.75.75.75h9a.75.75 0 010 1.5h-9z"}}),_c('path',{attrs:{"d":"M3.75 4.499a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM3.75 7.499a.75.75 0 010-1.5h6a.75.75 0 010 1.5h-6z"}})])
          )
        }
      }
    